import React from 'react';
import createReactClass from 'create-react-class';
import { ArrowLeft, ArrowRight } from 'Utils/SvgIcons';
import classnames from 'classnames';

/**
 * React Calendar Component v0.1.1
 *
 * Copyright 2016, Dimitar Ivanov
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */
var Calendar = createReactClass({
  displayName: 'Calendar',
  calc: function(year, month) {
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate(),
    };
  },
  UNSAFE_componentWillMount: function() {
    const { year, month } = this.state;
    this.setState(this.calc.call(null, year, month));
  },
  componentDidUpdate: function(prevProps) {
    const { date } = this.props;
    if (prevProps.date.getTime() !== date.getTime()) {
      const [year, month] = [date.getFullYear(), date.getMonth()];
      this.setState({ year, month, ...this.calc.call(null, year, month) });
    }
  },
  componentDidMount: function() {},
  getInitialState: function() {
    const { date, minDate, disablePast, preselectedDays } = this.props;

    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      selectedYear: date.getFullYear(),
      selectedMonth: date.getMonth(),
      selectedDate: date.getDate(),
      preselectedDays: preselectedDays,
      selectedDt: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      startDay: 0,
      weekNumbers: false,
      minDate: minDate ? minDate : null,
      disablePast: disablePast ? disablePast : false,
      dayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      monthNames: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      monthNamesFull: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      firstOfMonth: null,
      daysInMonth: null,
      lastRequestTime: new Date(),
    };
  },
  getPrev: function() {
    var state = {};
    if (this.state.month > 0) {
      state.month = this.state.month - 1;
      state.year = this.state.year;
    } else {
      state.month = 11;
      state.year = this.state.year - 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state, () => {
      this.props.onChangeMonthCallback(state.month, state.year);
    });
  },
  getNext: function() {
    var state = {};
    if (this.state.month < 11) {
      state.month = this.state.month + 1;
      state.year = this.state.year;
    } else {
      state.month = 0;
      state.year = this.state.year + 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state, () => {
      this.props.onChangeMonthCallback(state.month, state.year);
    });
  },
  selectDate: function(year, month, date, event) {
    event.persist();
    const currentTime = new Date();
    const limitRate = (lastRequestTime, currentTime, rate) => {
      let secondsDifference = (lastRequestTime - currentTime) / 1000;
      return secondsDifference < rate;
    };
    if (
      this.props.onSelectDate &&
      !limitRate(currentTime, this.state.lastRequestTime, 1.5)
    ) {
      this.setState(
        {
          selectedYear: year,
          selectedMonth: month,
          selectedDt: new Date(year, month, date),
          lastRequestTime: currentTime,
        },
        () => {
          this.props.onSelectDate(new Date(year, month, date), event);
        }
      );
    }
  },
  calculatePreselectedDays: function() {
    let { startDate, endDate } = this.props;

    if (!startDate || !endDate) return [];

    startDate = new Date(startDate);
    endDate = new Date(endDate);

    const { year: currentYear, month: currentMonth } = this.state;
    const [startMonth, startYear] = [
      startDate.getMonth(),
      startDate.getFullYear(),
    ];
    const endMonth = endDate && endDate.getMonth();
    const endYear = endDate && endDate.getFullYear();
    const validDate = startDate.getTime() <= endDate.getTime();
    const inRange =
      validDate &&
      !(
        currentYear < startYear ||
        currentYear > endYear ||
        (currentYear === startYear && currentMonth < startMonth) ||
        (currentYear === endYear && currentMonth > endMonth)
      );

    if (inRange) {
      let [end, start] = [0, 0];
      if (
        currentMonth === startDate.getMonth() &&
        currentMonth === endDate.getMonth() &&
        currentYear === startDate.getFullYear() &&
        currentYear === endDate.getFullYear()
      ) {
        [start, end] = [startDate.getDate(), endDate.getDate()];
      } else if (
        currentMonth === startDate.getMonth() &&
        currentYear === startDate.getFullYear()
      ) {
        start = startDate.getDate();
        end = new Date(
          startDate.getFullYear(),
          startDate.getMonth() + 1,
          0
        ).getDate();
      } else if (
        currentMonth === endDate.getMonth() &&
        currentYear === endDate.getFullYear()
      ) {
        [start, end] = [1, endDate.getDate()];
      } else {
        start = 1;
        end = new Date(currentYear, currentMonth + 1, 0).getDate();
      }
      return [...Array(end - start + 1).keys()].map((x) => x + start);
    } else {
      return [];
    }
  },
  render: function() {
    const {
      monthNames,
      month,
      year,
      dayNames,
      startDay,
      weekNumbers,
      daysInMonth,
      firstOfMonth,
      disablePast,
      minDate,
    } = this.state;
    const {
      highlight,
      selectedDate,
      datesArray,
      secondaryDatesArray,
      alertingDatesArray,
      withoutPop,
      showRentalHighlights,
      showInOut,
      product,
      navigationAllowed,
      withoutTitle,
      withoutWeekdays,
      productType,
      isDisabled,
      preselectedDays,
      isEditingRecurrence,
      isCustomRecurrence,
    } = this.props;

    const preselectedDaysCalculated = this.calculatePreselectedDays();

    return (
      <div className='r-calendar'>
        <div className='r-inner'>
          <Header
            monthNames={monthNames}
            month={month}
            year={year}
            onPrev={() => this.getPrev()}
            onNext={() => this.getNext()}
            navigationAllowed={navigationAllowed}
            withoutTitle={withoutTitle}
          />
          {!withoutWeekdays && (
            <WeekDays
              dayNames={dayNames}
              startDay={startDay}
              weekNumbers={weekNumbers}
            />
          )}
          <MonthDates
            selectedDate={selectedDate}
            highlightRange={highlight && !!preselectedDaysCalculated.length}
            preselectedDays={preselectedDays}
            preselectedDaysCalculated={preselectedDaysCalculated}
            month={month}
            year={year}
            daysInMonth={daysInMonth}
            firstOfMonth={firstOfMonth}
            startDay={startDay}
            onSelect={this.selectDate}
            weekNumbers={weekNumbers}
            disablePast={disablePast}
            minDate={minDate}
            datesArray={datesArray}
            secondaryDatesArray={secondaryDatesArray}
            alertingDatesArray={alertingDatesArray}
            withoutPop={withoutPop}
            showRentalHighlights={showRentalHighlights}
            showInOut={showInOut}
            product={product}
            productType={productType}
            isDisabled={isDisabled}
            isEditingRecurrence={isEditingRecurrence}
            isCustomRecurrence={isCustomRecurrence}
          />
        </div>
      </div>
    );
  },
});

class Header extends React.Component {
  static displayName = 'Header';

  render() {
    const {
      monthNames,
      month,
      year,
      navigationAllowed,
      withoutTitle,
      onPrev,
      onNext,
    } = this.props;
    return (
      <div className='r-row r-head'>
        {navigationAllowed && (
          <div
            className='r-cell r-prev'
            onClick={onPrev}
            role='button'
            tabIndex='0'
          >
            <ArrowLeft />
          </div>
        )}

        {!withoutTitle && (
          <div className='r-cell r-title'>
            {monthNames[month]} {year}
          </div>
        )}
        {navigationAllowed && (
          <div
            className='r-cell r-next'
            onClick={onNext}
            role='button'
            tabIndex='0'
          >
            <ArrowRight />
          </div>
        )}
      </div>
    );
  }
}

class WeekDays extends React.Component {
  static displayName = 'WeekDays';

  render() {
    const that = this,
      haystack = Array.apply(null, { length: 7 }).map(Number.call, Number);
    const dayNames = haystack.map((item, i) => (
      <div key={`week_days_${i}`} className='r-cell'>
        {that.props.dayNames[(that.props.startDay + i) % 7]}
      </div>
    ));
    return <div className='r-row r-weekdays'>{dayNames}</div>;
  }
}

class MonthDates extends React.Component {
  static defaultProps = {
    datesArray: [],
    alertingDatesArray: [],
    productType: 'items',
  };

  static displayName = 'MonthDates';
  static year = new Date().getFullYear();
  static month = new Date().getMonth();
  static date = new Date().getDate();

  static today = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  handleOnClick = (event, props, dc) => {
    const { isEditingRecurrence, isCustomRecurrence } = this.props;

    if (isEditingRecurrence && !isCustomRecurrence) {
      return;
    }
    props.onSelect(props.year, props.month, dc, event);
  };

  render() {
    var haystack,
      day,
      date,
      current,
      isDate,
      className,
      weekStack = Array.apply(null, { length: 7 }).map(Number.call, Number),
      that = this,
      startDay = this.props.firstOfMonth.getUTCDay(),
      first = this.props.firstOfMonth.getDay(),
      rows = 5;
    const {
      highlightRange,
      productType,
      isDisabled,
      preselectedDaysCalculated,
      preselectedDays,
      selectedDate,
    } = this.props;

    if (
      (startDay === 5 && this.props.daysInMonth === 31) ||
      (startDay === 6 && this.props.daysInMonth > 29)
    ) {
      rows = 6;
    }

    className = rows === 6 ? 'r-dates' : 'r-dates r-fix';
    haystack = Array.apply(null, { length: rows }).map(Number.call, Number);
    day = this.props.startDay + 1 - first;
    while (day > 1) {
      day -= 7;
    }
    day -= 1;

    return (
      <div
        className={classnames(className, {
          'selected-range': highlightRange,
          'margin-4': highlightRange,
        })}
      >
        {haystack.map((item, i) => {
          date = day + i * 7;
          return (
            <div key={`hay_stack_${i}`} className='r-row'>
              {weekStack.map((item, j) => {
                date += 1;
                isDate = date > 0 && date <= that.props.daysInMonth;
                const dc = date;

                if (isDate) {
                  current = new Date(that.props.year, that.props.month, date);
                  className =
                    current !== that.constructor.today
                      ? 'r-cell r-date'
                      : 'r-cell r-date r-today';

                  if (selectedDate) {
                    const selected = new Date(
                      selectedDate.getFullYear(),
                      selectedDate.getMonth(),
                      selectedDate.getDate()
                    );
                    if (current.getTime() === selected.getTime()) {
                      className += ' r-selected';
                    }
                  }

                  if (preselectedDays && productType !== 'bundles') {
                    if (preselectedDays.includes(current.getDate())) {
                      className += ' r-selected';
                    }
                  }
                  if (highlightRange) {
                    className += ' r-highlighted-range-blank';
                  }

                  if (isDisabled) {
                    return (
                      <div
                        key={`week_stack_${i}_${j}`}
                        className={'r-cell r-disabled'}
                        role='button'
                        tabIndex='0'
                      >
                        <div>{date}</div>
                      </div>
                    );
                  }

                  const {
                    datesArray,
                    secondaryDatesArray,
                    alertingDatesArray,
                    product,
                    withoutPop,
                    showRentalHighlights,
                    showInOut,
                  } = that.props;
                  if (showInOut) {
                    if (
                      datesArray.filter((dateHolder) => {
                        const startDate = new Date(dateHolder[0]);
                        const startTest = new Date(
                          startDate.getFullYear(),
                          startDate.getMonth(),
                          startDate.getDate()
                        );

                        const endDate = new Date(dateHolder[1]);
                        const endTest = new Date(
                          endDate.getFullYear(),
                          endDate.getMonth(),
                          endDate.getDate()
                        );

                        return (
                          startTest.getTime() === current.getTime() ||
                          current.getTime() === endTest.getTime()
                        );
                      }).length > 0
                    ) {
                      className += ' r-in-out';
                      return (
                        <div
                          key={`week_stack_${i}_${j}`}
                          className={className}
                          role='button'
                          tabIndex='0'
                          onClick={(event) =>
                            this.handleOnClick(event, that.props, dc)
                          }
                        >
                          <div>{date}</div>
                        </div>
                      );
                    }
                  }

                  if (showRentalHighlights) {
                    if (
                      datesArray.filter((dateHolder) => {
                        const startDate = new Date(dateHolder[0]);
                        const startTest = new Date(
                          startDate.getFullYear(),
                          startDate.getMonth(),
                          startDate.getDate()
                        );
                        const endDate = new Date(dateHolder[1]);
                        const endTest = new Date(
                          endDate.getFullYear(),
                          endDate.getMonth(),
                          endDate.getDate()
                        );
                        return startTest <= current && current <= endTest;
                      }).length
                    ) {
                      className += ' r-highlighted';
                      return (
                        <div
                          key={`week_stack_${i}_${j}`}
                          className={className}
                          role='button'
                          tabIndex='0'
                          onClick={(event) =>
                            this.handleOnClick(event, that.props, dc)
                          }
                        >
                          <div className='date-container'>{date}</div>
                        </div>
                      );
                    } else if (
                      secondaryDatesArray?.filter((dateHolder) => {
                        const startDate = new Date(dateHolder[0]);
                        const startTest = new Date(
                          startDate.getFullYear(),
                          startDate.getMonth(),
                          startDate.getDate()
                        );
                        const endDate = new Date(dateHolder[1]);
                        const endTest = new Date(
                          endDate.getFullYear(),
                          endDate.getMonth(),
                          endDate.getDate()
                        );
                        return startTest <= current && current <= endTest;
                      }).length
                    ) {
                      className += ' r-highlighted-border';
                      return (
                        <div
                          key={`week_stack_${i}_${j}`}
                          className={className}
                          role='button'
                          tabIndex='0'
                          onClick={(event) =>
                            this.handleOnClick(event, that.props, dc)
                          }
                        >
                          <div>{date}</div>
                        </div>
                      );
                    }
                  }
                  if (
                    alertingDatesArray &&
                    alertingDatesArray.filter((dateHolder) => {
                      const startDate = new Date(dateHolder[0]);
                      const startTest = new Date(
                        startDate.getFullYear(),
                        startDate.getMonth(),
                        startDate.getDate()
                      );
                      const endDate = new Date(dateHolder[1]);
                      const endTest = new Date(
                        endDate.getFullYear(),
                        endDate.getMonth(),
                        endDate.getDate()
                      );
                      return startTest <= current && current <= endTest;
                    }).length > 0
                  ) {
                    className += ' r-alerting';
                    return (
                      <div
                        key={`week_stack_${i}_${j}`}
                        className={className}
                        role='button'
                        tabIndex='0'
                        onClick={(event) =>
                          this.handleOnClick(event, that.props, dc)
                        }
                      >
                        <div className='date-container'>{date}</div>
                      </div>
                    );
                  } else if (
                    product !== undefined &&
                    datesArray.filter((dateHolder) => {
                      const startDate = new Date(dateHolder[0]);
                      const startTest = new Date(
                        startDate.getFullYear(),
                        startDate.getMonth(),
                        startDate.getDate()
                      );
                      const endDate = new Date(dateHolder[1]);
                      const endTest = new Date(
                        endDate.getFullYear(),
                        endDate.getMonth(),
                        endDate.getDate()
                      );
                      return startTest <= current && current <= endTest;
                    }).length > 0
                  ) {
                    className += ' r-highlighted';
                    return (
                      <div
                        key={`week_stack_${i}_${j}`}
                        className={className}
                        role='button'
                        tabIndex='0'
                        onClick={(event) =>
                          this.handleOnClick(event, that.props, dc)
                        }
                      >
                        <div className='date-container'>{date}</div>
                      </div>
                    );
                  }
                  return (
                    <div
                      key={`week_stack_${i}_${j}`}
                      className={className}
                      role='button'
                      tabIndex='0'
                      onClick={(event) =>
                        this.handleOnClick(event, that.props, dc)
                      }
                    >
                      <div className='date-container'>{date}</div>
                    </div>
                  );
                }
                return <div key={`week_stack_${i}_${j}`} className='r-cell' />;
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

Calendar.defaultProps = {
  productType: 'items',
  onChangeMonthCallback: () => {},
};

export default Calendar;
